import React from 'react';
import PanelDangerAlert from './PanelDangerAlert';
import PanelDangerTextBox from './PanelDangerTextBox';
import './index.css'; // Import the single CSS file that imports all others

// Define the field data interface
interface FieldData {
  label: string;
  value: string;
}

interface DangerPanelProps {
  // Fields array for displaying information
  fields: FieldData[];
  // Title for the panel (optional)
  title?: string;
  onClose: () => void;
}

const DangerPanel: React.FC<DangerPanelProps> = ({ fields, title = "DANGER", onClose }) => {
      
  return (
    <div className="danger-panel-overlay">
      <div className="danger-panel-content">
        {/* Logo/Alert component at the top */}
        <div className="danger-panel-item">
          <PanelDangerAlert title={title} />
        </div>
        
        {/* Text box with fields in the middle */}
        <div className="danger-panel-item">
          <PanelDangerTextBox fields={fields} />
        </div>
        
        {/* Close button at the bottom */}
        <div className="danger-panel-item">
          <button
            className="danger-close-btn"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DangerPanel;
